import React, {useEffect, useState} from "react";
import Select from "react-select";
import {get_report_options} from "../../../redux/reports";

/** @module Pages/Reports/Slicers */

/**
 * Segmentador "Básico" del Power BI: lista de valores con selección única. Al volver a hacer clic
 * en el valor seleccionado se limpia (todos).
 * @param {string} title - Título del segmentador
 * @param {array} options - [{value, label}]
 * @param {*} value - Valor seleccionado o null
 * @param {function} onChange
 * @param {boolean} horizontal - Mostrar como mosaicos en fila
 */
export const ListSlicer = ({title, options, value, onChange, horizontal = false}) => (
    <div className={`pbi-slicer ${horizontal ? "pbi-slicer--tiles" : "pbi-slicer--list"}`}>
        <div className="pbi-slicer__header">
            <span>{title}</span>
            {value !== null && value !== undefined ? (
                <button type="button" className="pbi-slicer__clear" title="Borrar selección" onClick={() => onChange(null)}>
                    <i className="bx bx-eraser"/>
                </button>
            ) : null}
        </div>
        <div className="pbi-slicer__items">
            {options.map((option) => {
                const selected = option.value === value;
                return (
                    <button
                        type="button"
                        key={option.value}
                        className={`pbi-slicer__item ${selected ? "is-selected" : ""}`}
                        aria-pressed={selected}
                        onClick={() => onChange(selected ? null : option.value)}
                    >
                        {!horizontal ? <span className="pbi-slicer__check"/> : null}
                        <span>{option.label}</span>
                    </button>
                );
            })}
        </div>
    </div>
);

/**
 * Segmentador "Lista desplegable" del Power BI con búsqueda y selección única (limpiar = todos).
 * Las opciones se cargan una sola vez desde la API.
 * @param {string} title - Título del segmentador
 * @param {string} field - nombre | centro_costo
 * @param {string} token
 * @param {string} value - Valor seleccionado o null
 * @param {function} onChange
 * @param {boolean} showHeader - Mostrar el título sobre el desplegable
 */
export const DropdownSlicer = ({title, field, token, value, onChange, showHeader = true}) => {
    const [options, setOptions] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        let active = true;
        if (!token) return undefined;
        setLoading(true);
        get_report_options(token, field)
            .then((data) => active && setOptions(data))
            .catch(() => active && setOptions([]))
            .finally(() => active && setLoading(false));
        return () => {
            active = false;
        };
    }, [token, field]);

    const selected = options.find((o) => o.value === value) || null;

    return (
        <div className="pbi-slicer pbi-slicer--dropdown">
            {showHeader ? <div className="pbi-slicer__header"><span>{title}</span></div> : null}
            <Select
                classNamePrefix="pbi-select"
                options={options}
                value={selected}
                isClearable
                isLoading={loading}
                placeholder="Todos"
                noOptionsMessage={() => "Sin resultados"}
                loadingMessage={() => "Cargando..."}
                aria-label={title}
                onChange={(option) => onChange(option ? option.value : null)}
            />
        </div>
    );
};
